import React from 'react';
import {Button} from '@lightricks/react-design-system';
import {Box, styled} from '@mui/material';
import translate from '@/utils/translate';

const StyledActionsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
}));

const StyledClearAllFiltersButton = styled(Button)(() => ({
  textDecoration: 'underline',
}));

const StyledApplyButton = styled(Button)(() => ({
  borderRadius: '5px',
}));

interface FiltersPopupActionButtonsProps {
  resultCount?: number | null;
  isLoadingCount?: boolean;
  onApplyClick: () => void;
  onResetClick: () => void;
}

function FiltersPopupActionButtons({
  resultCount,
  isLoadingCount,
  onApplyClick,
  onResetClick,
}: FiltersPopupActionButtonsProps) {
  return (
    <StyledActionsContainer>
      <StyledClearAllFiltersButton
        appearance="neutral"
        mode="plain"
        size="medium"
        onClick={onResetClick}
        data-testid="reset-button"
      >
        {translate('Clear all filters')}
      </StyledClearAllFiltersButton>
      <StyledApplyButton
        appearance="neutral"
        mode="filled"
        size="medium"
        onClick={onApplyClick}
        data-testid="apply-button"
        isLoading={isLoadingCount}
      >
        {translate('Show X Gigs_interval', {
          postProcess: 'interval',
          count: resultCount || 0,
        })}
      </StyledApplyButton>
    </StyledActionsContainer>
  );
}

export default FiltersPopupActionButtons;
